module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/3-d3fbbb641a47b605a05de9ae0c4f0176.jpg";